import PropTypes from 'prop-types';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import Stack from '@zenbusiness/zui/Stack';

import ContinueButton from '#client/pages/Checkout/components/ContinueButton';

import BusinessInfoSummary from '../BusinessInfoSummary';
import ContactInfoSummary from '../ContactInfoSummary';

function Summary({ onContinue }) {
  const { authenticated } = useAuthentication();

  return (
    <Stack data-testid="business-checkout-card-summary" spacing={1.5}>
      {!authenticated && <ContactInfoSummary />}
      <BusinessInfoSummary />
      {onContinue && <ContinueButton sx={{ mt: 1 }} onClick={onContinue} />}
    </Stack>
  );
}

Summary.propTypes = {
  onContinue: PropTypes.func
};

export default Summary;
